/* unplugin-vue-components disabled */import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "editor-drawer__images flex flex-col"
};
const _hoisted_2 = {
  class: "tabs tabs-bordered"
};
const _hoisted_3 = {
  class: "h-full"
};
const _hoisted_4 = {
  key: 2,
  class: "mt-2"
};
import UploadedImagesToolbar from '@/components/configurator/sidebar/drawer/UploadedImagesToolbar';
import UnsplashImagesToolbar from '@/components/configurator/sidebar/drawer/UnsplashImagesToolbar';
// import UploadImageToolbar from '@/components/configurator/sidebar/drawer/UploadImageToolbar'
import { useAuthStore } from '@/stores/auth';
export default {
  __name: 'EditorDrawerImages',
  setup(__props) {
    const $eventBus = inject('bus');
    const isActive = ref(1);
    const authStore = useAuthStore();
    const {
      token
    } = storeToRefs(authStore);
    const isUserLoggedIn = computed(() => {
      return token.value !== '';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("a", {
        class: _normalizeClass(["tab text-white", {
          'tab-active': _unref(isActive) === 1
        }]),
        onClick: _cache[0] || (_cache[0] = $event => isActive.value = 1)
      }, _toDisplayString(_ctx.$t('configurator.uploaded')), 3), _createElementVNode("a", {
        class: _normalizeClass(["tab text-white", {
          'tab-active': _unref(isActive) === 2
        }]),
        onClick: _cache[1] || (_cache[1] = $event => isActive.value = 2)
      }, _toDisplayString(_ctx.$t('configurator.unsplash')), 3)]), _createElementVNode("div", _hoisted_3, [_unref(isActive) === 1 && _unref(isUserLoggedIn) ? (_openBlock(), _createBlock(_unref(UploadedImagesToolbar), {
        key: 0
      })) : _createCommentVNode("", true), _unref(isActive) === 2 && _unref(isUserLoggedIn) ? (_openBlock(), _createBlock(_unref(UnsplashImagesToolbar), {
        key: 1
      })) : _createCommentVNode("", true), !_unref(isUserLoggedIn) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createTextVNode(" Please "), _createElementVNode("span", {
        class: "underline font-bold cursor-pointer",
        onClick: _cache[2] || (_cache[2] = $event => _unref($eventBus).$emit('open-login-modal', 'login'))
      }, "log in"), _createTextVNode(" to use this feature ")])) : _createCommentVNode("", true)])]);
    };
  }
};